import script from "./labels.vue?vue&type=script&lang=js"
export * from "./labels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/i18n/fr/labels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b4b0b8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b4b0b8a', __exports__)) {
    api.reload('5b4b0b8a', __exports__)
  }
  
}


export default __exports__